import { render } from "./InfraServicesTable.vue?vue&type=template&id=214113da&scoped=true"
import script from "./InfraServicesTable.vue?vue&type=script&lang=js"
export * from "./InfraServicesTable.vue?vue&type=script&lang=js"

import "./InfraServicesTable.vue?vue&type=style&index=0&id=214113da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214113da"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QTd,QBtn,QTooltip});
